import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
} from "antd";
import { EditOutlined, SearchOutlined, SkinOutlined, AuditOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

// PERMISSÃO
const options = [
  { value: 0, label: "Não" },
  { value: 1, label: "Sim" },
];

export const UniformesCadProdutosCargos = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState([]);

  // FILIAIS
  const [filiais, setFiliais] = useState([]);
  const [filialSelected, setFilialSelected] = useState(0);

  // PRODUTO
  const [produto, setProduto] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (id) {
      carregarProduto(id);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      listarProdutosCargos(id, filialSelected);
    }
  }, [id, filialSelected]);

  useEffect(() => {
    listarFiliais();
  }, []);

  // LISTAR FILIAIS
  const listarFiliais = async () => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos_cargos/listar_filiais`, []);
    if (api.statusCode === 200) {
      let options_filiais = [];
      options_filiais.push({ value: 0, label: "Todas" });
      for (const t of api.response.data) {
        options_filiais.push({ value: t.id, label: t.descricao });
      }
      setFiliais(options_filiais);
      setFilialSelected(0);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR PRODUTO
  const carregarProduto = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setProduto(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR CARGOS
  const listarProdutosCargos = async (id_produto, filial_selected) => {
    setLoading(true);
    const api = await http(
      "get",
      `v1/uniformes_produtos_cargos/listar/${id_produto}?id_cad_filiais=${filial_selected ? filial_selected : 0}`,
      []
    );
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarProdutoCargo = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos_cargos/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registros alterados com sucesso!");
      setShowModal(false);
      resetForm();
      listarProdutosCargos(id, filialSelected);
      setSelected([]);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Classificação",
      dataIndex: "classificacao",
      sorter: (a, b) => a.classificacao?.localeCompare(b.classificacao),
    },
    {
      title: "Cargo",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Percentual Desconto",
      dataIndex: "percentual_desconto",
      sorter: (a, b) => a.percentual_desconto?.toString()?.localeCompare(b.percentual_desconto?.toString()),
    },
    {
      title: "Nº Parcelas",
      dataIndex: "parcelas",
      sorter: (a, b) => a.parcelas?.toString()?.localeCompare(b.parcelas?.toString()),
    },
    {
      title: "Cota anual ped. c/desc",
      dataIndex: "cota_anual",
      sorter: (a, b) => a.cota_anual?.toString()?.localeCompare(b.cota_anual?.toString()),
    },
    {
      title: "Permite Pedido",
      dataIndex: "situacao",
      render: (_, e) => (e.situacao === 1 ? "Sim" : "Não"),
      sorter: (a, b) => (a.situacao === 1 ? "Sim" : "Não")?.localeCompare(b.situacao === 1 ? "Sim" : "Não"),
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (selected.length === 0) return;

    formulario.id_cad_filiais = filialSelected ? filialSelected : 0;
    formulario.id_uniformes_cad_produtos = id && id;
    formulario.cargos = selected;

    alterarProdutoCargo(formulario);
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.classificacao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.percentual_desconto?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.parcelas?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.cota_anual?.toString()?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> Editar Selecionados
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="percentual_desconto"
                label="Percentual de Desconto"
                rules={[
                  {
                    required: true,
                    message: "Informe o percentual de desconto!",
                  },
                ]}>
                <InputNumber
                  min={0}
                  max={100}
                  precision={2}
                  size="large"
                  disabled={loading}
                  placeholder="Informe o percentual de desconto!"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="numero_parcelas"
                label="Nº de parcelas"
                rules={[{ required: true, message: "Informe o nº de parcelas!" }]}>
                <InputNumber
                  min={0}
                  precision={0}
                  size="large"
                  disabled={loading}
                  placeholder="Informe o nº de parcelas!"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="cota_anual"
                label="Cota anual de pedidos c/ desconto"
                rules={[{ required: true, message: "Informe a cota anual!" }]}>
                <InputNumber
                  min={0}
                  precision={0}
                  size="large"
                  disabled={loading}
                  placeholder="Informe a cota anual!"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="permite_pedido"
                label="Permite Pedido"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  const onCheck = async (dados_selected, dados) => {
    setLoading(true);
    let array_dados = [];
    dados?.map((e) => {
      array_dados.push(e.id);
    });

    setSelected((array) =>
      array.filter(function (x) {
        return array_dados.indexOf(x) < 0;
      })
    );
    setSelected((val) => [...val, ...dados_selected]);

    setLoading(false);
  };

  // CHECK ROW
  const rowSelection = {
    type: "checkbox",
    disabled: true,
    selectedRowKeys: selected,
    onSelectAll: (e) => {
      if (loading) return;
      let array = [];
      if (e === true) array = dadosFilter.map((e) => e.id);

      onCheck(array, dadosFilter);
    },
    onSelect: (data, status) => {
      if (loading) return;
      onCheck(status ? [data.id] : [], [{ id: data.id }]);
    },
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/uniformes/gestao-produtos")} />
            <HeaderTitle
              title="Uniformes Produtos Cargos"
              subtitle={
                <Text italic>
                  <SkinOutlined /> {produto?.descricao ?? ""}
                </Text>
              }
              icon={<AuditOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Select
                  defaultValue={0}
                  showSearch
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%", minWidth: 180 }}
                  options={filiais}
                  onChange={(e) => setFilialSelected(e)}
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                />
                <Button
                  type="primary"
                  icon={<EditOutlined />}
                  disabled={selected.length === 0}
                  onClick={() => {
                    setShowModal(true);
                    resetForm();
                  }}
                  loading={loading}>
                  Editar Selecionados
                </Button>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                rowSelection={rowSelection}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
